import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';

import { LayoutSplashScreen } from '../../../_metronic';
import getMenuConfig from '../../router/MenuConfig';
import * as builder from '../../../_metronic/ducks/builder';
import { actions as profileActions } from '../../store/ducks/profile.duck';
import { IAppState } from '../../store/rootDuck';

const UsersPage = lazy(() => import('./users'));
const PromocodesPage = lazy(() => import('./promocodes'));
const RefferalsPage = lazy(() => import('./referrals'));
const UserDocPage = lazy(() => import('./userDocs'));
const SettingsPage = lazy(() => import('./settings'));
const TariffsPage = lazy(() => import('./tariffs'));
const TransactionsPage = lazy(() => import('./transactions'));
const ChatsPages = lazy(() => import('./chats'));
const ReadDocPage = lazy(() => import('./userDocs/ReadDocPage'));

const HomePage: React.FC<TPropsFromRedux & { userLastLocation: any }> = ({
  userRoles,
  isAuthorized,
  setMenuConfig,
  fetchMe,
}) => {
  const [menuConfig] = useState(getMenuConfig(userRoles || [], isAuthorized));

  // for user profile in header
  useEffect(() => {
    fetchMe();
  }, []);

  useEffect(() => {
    setMenuConfig(menuConfig);
  }, [setMenuConfig, menuConfig]);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /catalog. */
          <Redirect exact from='/' to='settings/profile' />
        }

        <Route path='/settings' component={SettingsPage} />

        <Route path='/documents' component={UserDocPage} />
        <Route path='/users' component={UsersPage} />
        <Route path='/tariffs' component={TariffsPage} />
        <Route path='/promocodes' component={PromocodesPage} />
        <Route path='/chats' component={ChatsPages} />
        <Route path='/refferals' component={RefferalsPage} />
        <Route path='/transactions' component={TransactionsPage} />
        <Route path='/document/read/:type' component={ReadDocPage} />

        <Redirect to='/error/error-v1' />
      </Switch>
    </Suspense>
  );
};

const connector = connect(
  (state: IAppState) => ({
    userRoles: state.auth.user?.roles,
    isAuthorized: state.auth.user != null,
    isAdmin: state.auth.user?.is_admin,
  }),
  {
    fetchMe: profileActions.fetchRequest,
    editMe: profileActions.editRequest,
    setMenuConfig: builder.actions.setMenuConfig,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HomePage);
